import type { Actions, State } from '../state'
import type { Dispatch } from 'react'
import { createContext } from 'react'

type TActivitiesContext = [
  state: State,
  dispatch: Dispatch<Actions | Promise<Actions>>,
]

export const ActivitiesContext = createContext<TActivitiesContext | undefined>(
  undefined,
)
